import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-user-group-modal',
  templateUrl: './user-group-modal.component.html',
  styleUrls: ['./user-group-modal.component.css']
})
export class UserGroupModalComponent implements OnInit, OnDestroy {

  @ViewChild("values", { static: false }) valueRef: ElementRef | undefined;
  @ViewChild('allSelected') private allSelected: MatOption;
  @Input() userGroupData: any;
  @Input() userGroupAdd: any;
  @Input() userGroupView: any;
  @Input() userGroupEdit: any;

  userGroupForm: FormGroup;
  formSubmitted: boolean = false;
  featurePrivilegeList: any = [];
  errorMessage: any = null;
  searchTerm: any = null;
  clearDropDownSearch: boolean = false;

  private _loading: boolean = false;
  private _values: any;
  private _featurePrivilegeListOriginal: any;
  private _afterClosedSubscription: Subscription;
  private _getFeatureListSubscription: Subscription;
  private _userGroupActionSubscription: Subscription;
  private _editUserGroupActionSubscription: Subscription;
  
  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _dialog: MatDialog
  ) {
    this.userGroupForm = this._fb.group({
      index: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      groupName: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      privilege: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this._loadConfigurationModalData();
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
    this._getFeatureListSubscription?.unsubscribe();  
    this._userGroupActionSubscription?.unsubscribe();  
    this._editUserGroupActionSubscription?.unsubscribe();  
    
  }
  get formValues() {
    return this.userGroupForm.controls;
  }

  closeModal() {
    if (this.userGroupForm.dirty) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: Messages.UNSAVED_CHANGES, type: null },
        disableClose: true
      });
      this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._activeModal.close();
        }
      });
    }
    else {
      this._activeModal.close();
    }
  }
  onSubmit() {
    this.formSubmitted = true;
    if (this.userGroupForm.invalid) {
      return;
    }
    if (this.userGroupForm.value['privilege'].includes(0)) {
      this.userGroupForm.value['privilege'].shift(0);
    }
    if (this.userGroupEdit) {
      this._editPrivilege();
    } else {
      this._addPrivilege();
    }
  }
  
  tosslePerOne(all) {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }
    if (this.userGroupForm.value.privilege.length === this._featurePrivilegeListOriginal.length)
      this.allSelected.select();
    return true;
  }
  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.userGroupForm.patchValue({ privilege: [0, ...this.featurePrivilegeList.map((item: any) => item.name)] });
    } else {
      this.userGroupForm.patchValue({ privilege: [] })
    }
  }

  triggerEvent(event: any) {
    this.clearDropDownSearch = true;
    this.searchTerm = null;
  }
  
  private _loadConfigurationModalData() {
    this._loading = true;
    this.featurePrivilegeList.length = 0;
    this._getFeatureListSubscription = this._service.getFeatureList().subscribe((res: any) => {
      this._loading = false;
      if (res['status']) {
        if (res['response'] && res['response']['data'].length > 0) {
          let data: any = res['response']['data'];
          this._featurePrivilegeListOriginal = data;
          data.forEach((element: any, index: any) => {
            // let d: any = { id: element['featureId'], name: element['featureId'] + "-" + element['featureName'] }
            let d: any = { id: element['featureId'], name: element['featureId'], label: element['featureName'] };
            this.featurePrivilegeList = this.featurePrivilegeList.concat(d);
          });
        }
      }
      if (this.userGroupData) {
        if (this.userGroupView) {
          this.userGroupForm.disable();
        }
      }
      this._patchValues();
    })
  }

  private _patchValues() {
    if (this.userGroupAdd) {
      this.userGroupForm.patchValue({ index: this.userGroupForm.value.index, groupName: this.userGroupForm.value.groupName, privilege: this.userGroupForm.value.privilege });
    } else {
      if (this._featurePrivilegeListOriginal.length === this.userGroupData.privilege.length) {
        this.userGroupData.privilege.unshift(0);
      }
      this.userGroupForm.patchValue({
        index: this.userGroupData.index, groupName: this.userGroupData.groupName, privilege: this.userGroupData.privilege
      });
    }
  }
  private _addPrivilege() {
    this.errorMessage = null;
    this._loading = true;
    let privilege: any = []
    if (this.userGroupForm.value['privilege'].length > 0) {
      this.userGroupForm.value['privilege'].forEach((element: any) => {
        if (element['id'] || element['id'] == 0) {
          privilege.push(element['id'])
        } else {
          privilege.push(element)
        }
      });
    }
    let userGroupDetails: any;
    userGroupDetails = {
      index: this.userGroupForm.value.index,
      groupName: this.userGroupForm.value.groupName,
      privilege: privilege
    }
    this._userGroupActionSubscription = this._service.userGroupAction(userGroupDetails, 'add').subscribe((result: any) => {
      if (result["status"] && result["response"]) {
        if (result["status"]) {
          this._service.toasterService({ type: 'success', msg: result['response']['message'] });
          this._loading = false;
          this._activeModal.close(true);
        } else {
          this.errorMessage = result['response']['message'];
          // this.service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      } else {
        if (result["response"]) {
          this.errorMessage = result['response']['message'];
          // this.service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      }
    })
  }

  private _editPrivilege() {
    this.errorMessage = null;
    this._loading = true;
    let userGroupDetails: any;
    if (!this.userGroupForm.controls['index'].dirty) {
      this.userGroupForm.value.index = null;
      this.userGroupForm.controls['index'].clearValidators();
    }
    if (!this.userGroupForm.controls['groupName'].dirty) {
      this.userGroupForm.value.groupName = null;
      this.userGroupForm.controls['groupName'].clearValidators();
    }
    let privilege: any = []
    if (this.userGroupForm.value['privilege']) {
      if (this.userGroupForm.value['privilege'].length > 0) {
        this.userGroupForm.value['privilege'].forEach((element: any) => {
          if (element['id'] || element['id'] == 0) {
            privilege.push(element['id'])
          } else {
            privilege.push(element)
          }
        });
      }
    }
    userGroupDetails = {
      index: this.userGroupForm.value.index,
      groupName: this.userGroupForm.value.groupName,
      privilege: privilege
    }
    this._editUserGroupActionSubscription = this._service.userGroupAction(userGroupDetails, 'update', this.userGroupData["_id"]).subscribe((result: any) => {
      if (result["status"] && result["response"]) {
        if (result["status"]) {
          this._service.toasterService({ type: 'success', msg: result['response']['message'] });
          this._loading = false;
          this._activeModal.close(true);
        } else {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this.service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      } else {
        if (result["response"]) {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this.service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      }
    })
  }

}
